"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallBackSuccess = void 0;
const react_1 = __importStar(require("react"));
const AuthenticateError_component_1 = __importDefault(require("./AuthenticateError.component"));
const oidc_1 = __importDefault(require("../../vanilla/oidc"));
const withRouter_1 = require("../routes/withRouter");
const CallBackSuccess = () => (react_1.default.createElement("div", { className: "oidc-callback" },
    react_1.default.createElement("div", { className: "oidc-callback__container" },
        react_1.default.createElement("h1", { className: "oidc-callback__title" }, "Authentication complete"),
        react_1.default.createElement("p", { className: "oidc-callback__content" }, "You will be redirected to your application."))));
exports.CallBackSuccess = CallBackSuccess;
const CallbackManager = ({ callBackError, callBackSuccess, configurationName, withCustomHistory }) => {
    const [error, setError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const playCallbackAsync = () => __awaiter(void 0, void 0, void 0, function* () {
            const getOidc = oidc_1.default.get;
            try {
                const { callbackPath } = yield getOidc(configurationName).loginCallbackWithAutoTokensRenewAsync();
                const history = (withCustomHistory) ? withCustomHistory() : (0, withRouter_1.getCustomHistory)();
                history.replaceState(callbackPath || "/");
            }
            catch (error) {
                if (isMounted) {
                    setError(true);
                }
            }
        });
        playCallbackAsync();
        return () => {
            isMounted = false;
        };
    }, []);
    const CallbackErrorComponent = callBackError || AuthenticateError_component_1.default;
    const CallbackSuccessComponent = callBackSuccess || exports.CallBackSuccess;
    if (error) {
        return react_1.default.createElement(CallbackErrorComponent, { configurationName: configurationName });
    }
    return react_1.default.createElement(CallbackSuccessComponent, { configurationName: configurationName });
};
exports.default = CallbackManager;
//# sourceMappingURL=Callback.component.js.map